import { Outlet } from 'react-router-dom';

/**
 * AccountsLayout — simple wrapper for accounts nested routes.
 * Navigation is now handled by the main app sidebar (paths.ts NAV_GROUPS).
 * This layout just provides the content outlet.
 */
export function AccountsLayout() {
  return (
    <div className="h-full overflow-auto">
      <Outlet />
    </div>
  );
}
